import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loader from "../components/common/loader";
const PrivateRoute = ({
    children,
    restrictedRoles,
    redirectTo = "/page-restricted",
}) => {
    const { isAuthenticated, user, loading } = useAuth();

    if (loading) {
        return <Loader />;
    }

    if (!isAuthenticated) {
        window.location.href =
            "https://ambit.ssoone.com?appnamesso1=ambit_mis_analytics";
        return null;
    }

    if (restrictedRoles?.length && restrictedRoles.includes(user?.role)) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
};

export default PrivateRoute;
